import { jsx as _jsx } from "react/jsx-runtime";
import { OrderBoolAscendingVariant } from "sprout-ui-icons";
import { PageToolbarItem as BasePageToolbarItem } from "@sprout/client-components/dist/PageToolbar";
import styled from "styled-components";
import { media } from "sprout-ui-theme";
const PageToolbarItem = styled(BasePageToolbarItem)`
  ${media.down("small")} {
    display: none;
  }
`;
const PostPageToolbarItemTodoList = ()=>{
    return /*#__PURE__*/ _jsx(PageToolbarItem, {
        action: "ADD_TODOLIST",
        label: "List",
        icon: OrderBoolAscendingVariant
    });
};
export default PostPageToolbarItemTodoList;
